import React from 'react';
import { observer } from 'mobx-react';
import ContractProductsModal from './ContractProductsModal';
import { toJS } from 'mobx';
import { BRAZIL } from '../../../core/consts';
import UpgradeContractFormService from '../services/UpgradeContractFormService';

class UpgradeContractProductsModalContainer extends React.Component {
  render() {
    return (
      <ContractProductsModal
        options={toJS(UpgradeContractFormService.productsService.products)}
        onChange={UpgradeContractFormService.productsService.form.setValue}
        values={UpgradeContractFormService.productsService.form.getValues()}
        onSubmit={UpgradeContractFormService.productsService.handleSubmit}
        errors={UpgradeContractFormService.productsService.form.errors}
        onDelete={UpgradeContractFormService.productsService.handleDelete}
        loading={UpgradeContractFormService.productsService.fetch.fetching}
        submitting={UpgradeContractFormService.submit.fetching}
        currencyType={
          !UpgradeContractFormService.form.getValue('country') ||
          BRAZIL.includes(UpgradeContractFormService.form.getValue('country'))
            ? 'real'
            : 'dollar'
        }
        isModalOpen={UpgradeContractFormService.productsService.isModalOpen}
        isEditingProduct={UpgradeContractFormService.productsService.isEditing}
        type={toJS(UpgradeContractFormService.contract.type)}
        onReset={UpgradeContractFormService.productsService.form.reset}
        onClose={UpgradeContractFormService.productsService.handleToggleModal}
        onAddRange={UpgradeContractFormService.productsService.handleAddRange}
        onDeleteRange={UpgradeContractFormService.productsService.handleDeleteRange}
      />
    );
  }
}

export default observer(UpgradeContractProductsModalContainer);
